// extracted by mini-css-extract-plugin
export default {"Payment":"Payment_Payment__AJt9E","Large":"Payment_Large__jApWC"};